import { Button } from "@/core/components/ui/button";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { formatPersistentEditValue } from "@/payroll/ai-script/ai-script-persistent-edits-utils";
import type { IAiSpreadsheetOverrideCandidate } from "@/payroll/ai-script/types";
import { EditCard } from "./shared";

interface RowPickerCandidateProps {
  candidate: IAiSpreadsheetOverrideCandidate;
  isEditable: boolean;
  isSelected: boolean;
  isPending: boolean;
  onView: () => void;
  onSelect: () => void;
}

export const RowPickerCandidate = ({
  candidate,
  isEditable,
  isSelected,
  isPending,
  onView,
  onSelect,
}: RowPickerCandidateProps) => (
  <EditCard>
    <Stack direction="row" gap="sm" align="center" justify="between" fullWidth>
      <Stack gap="none" className="min-w-0 flex-1">
        <Typography variant="subtitleW3" className="truncate">
          {candidate.sheet_name} · {candidate.address}
        </Typography>
        <Typography
          variant="captionW1"
          textColor="tertiary"
          className="break-words"
        >
          Currently {formatPersistentEditValue(candidate.value)}
        </Typography>
      </Stack>
      <Stack direction="row" gap="sm" align="center" className="shrink-0">
        <Button variant="tertiary" size="xs" onClick={onView}>
          View
        </Button>
        <Button
          variant="secondary"
          size="xs"
          loading={isSelected}
          disabled={!isEditable || isPending}
          onClick={onSelect}
        >
          {isSelected ? "Applying…" : isEditable ? "Use this row" : "View only"}
        </Button>
      </Stack>
    </Stack>
  </EditCard>
);
